var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 8.2002H7.5C7.2 8.2002 7 8.4002 7 8.7002C7 9.0002 7.2 9.2002 7.5 9.2002H13.7C14 9.2002 14.2 9.0002 14.2 8.7002C14.2 8.4002 13.9 8.2002 13.7 8.2002Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 10.9004H7.5C7.2 10.9004 7 11.1004 7 11.4004C7 11.7004 7.2 11.9004 7.5 11.9004H13.7C14 11.9004 14.2 11.7004 14.2 11.4004C14.2 11.1004 13.9 10.9004 13.7 10.9004Z",
    fill: "#007AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 13.6001H7.5C7.2 13.6001 7 13.8001 7 14.1001C7 14.4001 7.2 14.6001 7.5 14.6001H10.6C10.9 14.6001 11.1 14.4001 11.1 14.1001C11.1 13.8001 10.9 13.6001 10.6 13.6001Z",
    fill: "#007AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.2002H15H6C5.5 4.2002 5 4.4002 4.6 4.8002C4.2 5.2002 4 5.7002 4 6.3002V18.2002C4 18.7002 4.2 19.3002 4.6 19.6002C5 20.0002 5.5 20.3002 6 20.3002H15C15.5 20.3002 16.1 20.1002 16.4 19.7002C16.8 19.3002 17 18.8002 17 18.2002V12.9002C17.3 13.1002 17.6 13.2002 18 13.2002C19.1 13.2002 20 12.3002 20 11.2002V6.2002C20 5.1002 19.1 4.2002 18 4.2002ZM15.7 19.0002C15.5 19.2002 15.3 19.3002 15 19.3002H6C5.7 19.3002 5.5 19.2002 5.3 19.0002C5.1 18.8002 5 18.5002 5 18.2002V6.3002C5 6.0002 5.1 5.7002 5.3 5.5002C5.5 5.3002 5.7 5.2002 6 5.2002H15C15.3 5.2002 15.5 5.3002 15.7 5.5002C15.9 5.7002 16 6.0002 16 6.3002V11.3002V18.3002C16 18.5002 15.9 18.8002 15.7 19.0002ZM19 11.2002C19 11.8002 18.6 12.2002 18 12.2002C17.5 12.2002 17 11.8002 17 11.2002V6.2002C17 5.6002 17.4 5.2002 18 5.2002C18.6 5.2002 19 5.6002 19 6.2002V11.2002Z",
    fill: "#007AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.ed561a8607cbc2e79c2232fba0fb4717.svg";
export { ForwardRef as ReactComponent };